/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

const Vue = require('vue');

Vue.transition('fade');
Vue.transition('shake')



// WEBPACK FOOTER //
// ./src/common/components/lib/transition.js